import { datadogRum } from '@datadog/browser-rum';
var hasAllDatadogEnvs = function () {
    return (process.env.DATADOG_ID &&
        process.env.DATADOG_TOKEN &&
        process.env.DATADOG_ENV &&
        process.env.DATADOG_SERVICE);
};
var emailRegex = /email=[^&]*/;
var phoneRegex = /phone_number=[^&]*/;
var countryRegex = /country=[^&]*/;
var sanitizeQuery = function (url) {
    return url
        .replace(new RegExp(emailRegex, 'g'), 'email=REDACTED')
        .replace(new RegExp(phoneRegex, 'g'), 'phone_number=REDACTED')
        .replace(new RegExp(countryRegex, 'g'), 'country=REDACTED');
};
if (hasAllDatadogEnvs() && !process.env.REACT_APP_LOCAL_CG_ENV) {
    datadogRum.init({
        applicationId: process.env.DATADOG_ID,
        clientToken: process.env.DATADOG_TOKEN,
        env: process.env.DATADOG_ENV,
        site: 'datadoghq.com',
        service: process.env.DATADOG_SERVICE,
        // Specify a version number to identify the deployed version of your application in Datadog
        version: process.env.DATADOG_RUM_VERSION,
        sampleRate: 100,
        trackInteractions: false,
        defaultPrivacyLevel: 'mask',
        allowedTracingOrigins: [
            /https:\/\/.*\.springhealth\.com/,
            /https:\/\/.*\.springhealth\.cloud/,
            /https:\/\/.*\.springtest\.us/,
            /https:\/\/.*\.springhealth\.us/,
            /https:\/\/.*\.on-aptible.\.com/,
        ],
        tracingSampleRate: 100,
        beforeSend: function (event) {
            var _a, _b, _c;
            var resourceEvent = event;
            ((_a = event === null || event === void 0 ? void 0 : event.view) === null || _a === void 0 ? void 0 : _a.url) && (event.view.url = sanitizeQuery(event.view.url));
            ((_b = event === null || event === void 0 ? void 0 : event.view) === null || _b === void 0 ? void 0 : _b.referrer) && (event.view.referrer = sanitizeQuery(event.view.referrer));
            ((_c = resourceEvent === null || resourceEvent === void 0 ? void 0 : resourceEvent.resource) === null || _c === void 0 ? void 0 : _c.url) &&
                (resourceEvent.resource.url = sanitizeQuery(resourceEvent.resource.url));
        },
    });
}
export var datadogIdentify = function (id) {
    if (id) {
        datadogRum.setUser({ id: id });
    }
};
